import {defineStore} from 'pinia'
import api from '@/services/api'
import {usePagesStore} from '@/stores/pages'

export const useSelectMenuOptionsStore = defineStore('selectMenuOptions', {
    state: () => ({
        data: {},
    }),
    
    actions: {
        async get({tableName, fieldName, optionsArray}) {
            const key = `${tableName}:${fieldName}`
            
            if (this.data[key]) return this.data[key]
            
            let options
            if (tableName === 'pages' && fieldName === 'class') {
                const pagesStore = usePagesStore()
                options = await pagesStore.getClassNames()
            } else {
                options = optionsArray ? optionsArray.map((o) => o.value) : []
                
                const response = await api.get('api/component/' + tableName + '/' + fieldName, {
                    params: {
                        groupBy: fieldName,
                        sort: fieldName,
                        // Not all components have an archive option. To reinstate this it will need to check
                        // the component's settings.
                        //isArchived: 0
                    },
                })
                let values = response.data.values.filter(Boolean)
                
                options.push(...values)
            }
            
            const formattedOptions = [...new Set(options)] // Remove duplicates
                .map((value) => ({value, text: value}))
                .sort((a, b) => (a.text > b.text ? 1 : -1))
            
            this.data[key] = formattedOptions
            
            return formattedOptions
        },
        
        clearData({tableName}) {
            Object.keys(this.data)
                .filter((key) => key.startsWith(`${tableName}:`))
                .forEach((key) => delete this.data[key])
        },
    },
})